exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contextmenu {\n  width: 140px;\n  margin: 0;\n  border: 1px solid #ccc;\n  background: #fff;\n  z-index: 3000;\n  position: absolute;\n  list-style-type: none;\n  padding: 5px 0;\n  border-radius: 0;\n  font-size: 14px;\n  color: #333;\n  -webkit-box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.2);\n          box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.2);\n}\n.contextmenu li {\n  text-align: center;\n  margin: 0;\n  padding: 7px 16px;\n}\n.contextmenu li:hover {\n  background: #f2f2f2;\n  cursor: pointer;\n}\n.router-history {\n  background: #fff;\n  padding: 0 26px;\n  border-top: 1px solid #dcdcdc;\n}", ""]);

// exports
